import { Pressable, Text } from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';

export interface EditMenuItem {
    label: string;
    onPress: () => void;
    color?: string;
}

export type MarkAsDoneProps = {
    onPress: () => void;
}

export const EditMenuItem = ({label, color, onPress}: EditMenuItem) => {


  return(
    <Pressable style={{marginHorizontal: SPACING['sp-16'], width: '100%', height: SPACING['sp-40'], justifyContent: 'center'}} onPress={onPress}>
      <Text style={[{fontSize: 17}, !!color && {color: color}]}>
        {label}
      </Text>

    </Pressable>

  );

};

